export enum CharterInvoiceAuthorizationStateEnum {
  Unconfirmed_Invoice = 1,
  Confirmed_Invoice = 2,
  Signed_Contract = 3,
  Vendor_Signed_Contract = 4,
}
